import React, { Component } from 'react';
import Button from '@tencent/dui/lib/components/Button';
import './index.less';
import Style from './index.less';

export default class LiveEndMeetingDialog extends Component {


    constructor(props) {
        super(props);
        this.inputBar = null;
    }

    render() {
        return (
            <div className={'dialog-wrapper-endMeeting ' + Style['dialog-wrapper-endMeeting']}>
                <button aria-label="Close" className={'modal-close-endMeeting ' + Style['modal-close-endMeeting']} onClick={this.props.handleCloseDialog}><span className={'modal-close-x-endMeeting ' + Style['modal-close-x-endMeeting']}></span></button>
                <div className={'modal-content-endMeeting ' + Style['modal-content-endMeeting']}>
                    <h1>结束语音通话</h1>
                    <p className={'modal-p-endMeeting ' + Style['modal-p-endMeeting']}>关闭后所有好友将退出语音通话，远程演示继续进行</p>
                    <Button className={'cancel-btn-endMeeting ' + Style['cancel-btn-endMeeting']} onClick={this.props.handleCloseDialog}>取消</Button>
                    <Button type="primary" className={'sure-btn-endMeeting ' + Style['sure-btn-endMeeting']} onClick={this.props.handleQuitMeeting}>确定</Button>
                </div>
            </div>
        );
    }
}